import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class AccountsModel extends BaseModel {

    constructor() {
        super({
            name: "accounts",
            tableName: 'accounts',
            label: "accounts",
            display_key: 'name',
            default_order: { key: 'ordinal', direction: 'asc' }
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            uid: {
                name: 'uid',
                type: "Uuid",
                label: 'ID',
                display: false
            },
            account:{
                name: 'account',
                type: "String",
                label: 'Tài khoản',
                class: "center",
                filter: {type: 'input', match: 'contains'},
                display: false
            },
            type: {
                name: 'type',
                type: "String",
                label: 'Loại',
                display: false
            },
            },
        )
    }

}